import { ExternalSourceTypes } from '@interfaces/account';

const assets = [
  ExternalSourceTypes.CASH,
  ExternalSourceTypes.EXTERNAL_INVESTMENT_ACCOUNT,
  ExternalSourceTypes.REAL_ESTATE,
  ExternalSourceTypes.VEHICLES,
  ExternalSourceTypes.VALUABLES,
  ExternalSourceTypes.OTHER_ASSET,
];
const liabilities = [
  ExternalSourceTypes.LOANS,
  ExternalSourceTypes.MORTGAGE,
  ExternalSourceTypes.CREDIT_CARD,
  ExternalSourceTypes.OTHER_LIABILITY,
];

export const MAP_EXTERNAL_SOURCE_TYPE = { assets, liabilities };

export const getNetWorthType = (
  externalSourceType: ExternalSourceTypes | undefined,
): 'assets' | 'liabilities' | 'unknown' => {
  if (!externalSourceType || assets.includes(externalSourceType))
    return 'assets';
  if (liabilities.includes(externalSourceType)) return 'liabilities';
  return 'unknown';
};
